import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";
import { getParameterValues } from "hb/insights/query_parameters";

export default class extends Controller {
  static targets = ["parametersList", "emptyState"];

  connect() {
    this.element.addEventListener("show.bs.modal", () => {
      this.populateParameters();
    });

    this.openHandler = () => {
      Modal.getOrCreateInstance(this.element).show();
    };
    window.addEventListener("parametersModal:open", this.openHandler);
  }

  disconnect() {
    window.removeEventListener("parametersModal:open", this.openHandler);
  }

  populateParameters() {
    const widgets = document.querySelectorAll(
      '[data-controller*="insights--dashboard--grid-item"]',
    );
    const queries = Array.from(widgets).map(
      (w) => w.dataset.insightsDashboardGridItemQueryValue || "",
    );

    // Include the query being edited in the config panel (not yet saved to the widget)
    const editingConfig = document.querySelector(
      '[data-controller*="insights--widgets--insights-vis-config-component"][data-query]',
    );
    if (editingConfig?.dataset.query) {
      queries.push(editingConfig.dataset.query);
    }

    // On the standalone query page, read from the query textarea
    const queryTextarea = document.querySelector(
      '[data-controller*="insights--query-component"] textarea[id="query"]',
    );
    if (queryTextarea?.value) {
      queries.push(queryTextarea.value);
    }

    const params = getParameterValues(queries);

    if (params.length === 0) {
      this.emptyStateTarget.style.display = "block";
      this.parametersListTarget.innerHTML = "";
      return;
    }

    this.emptyStateTarget.style.display = "none";
    this.parametersListTarget.innerHTML = params
      .map(
        (p) => `
      <div class="mb-3">
        <label class="form-label">
          ${this.escapeHtml(p.name)}
          ${this.defaultLabel(p)}
        </label>
        <input type="text"
               class="form-control"
               data-param-name="${this.escapeHtml(p.name)}"
               data-initial-value="${this.escapeHtml(p.value)}"
               value="${this.escapeHtml(p.value)}"
               placeholder="${this.placeholderFor(p)}">
      </div>
    `,
      )
      .join("");
  }

  apply() {
    const url = new URL(window.location);
    const inputs = this.parametersListTarget.querySelectorAll(
      "input[data-param-name]",
    );

    let didChange = false;

    inputs.forEach((input) => {
      const paramName = input.dataset.paramName;
      const value = input.value.trim();
      const initialValue = (input.dataset.initialValue || "").trim();

      if (value === initialValue) {
        return;
      }

      if (value) {
        url.searchParams.set(paramName, value);
      } else {
        url.searchParams.delete(paramName);
      }

      didChange = true;
    });

    if (didChange) {
      history.replaceState({}, "", url);
      window.dispatchEvent(new CustomEvent("urlchanged"));
    }

    Modal.getInstance(this.element)?.hide();
  }

  defaultLabel(param) {
    if (param.defaultState === "consistent") {
      return '<span class="text-muted small">(has default)</span>';
    }
    if (param.defaultState === "varies") {
      return '<span class="text-muted small">(varies by widget)</span>';
    }
    if (param.defaultState === "required") {
      return '<span class="text-muted small">(required)</span>';
    }
    return "";
  }

  placeholderFor(param) {
    if (param.defaultState === "consistent") {
      return "Using inline default";
    }
    if (param.defaultState === "varies") {
      return "Varies by widget";
    }
    return "Required";
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
